import { defineQuery } from 'next-sanity';

export const OUR_TEAM_QUERY = defineQuery(
  `*[_type == "about"][0]{
    member[]->{ _id, title, name, image }
  }`,
);
